<footer class="footer-wrapper">
  <div class="logo-container">
    <img [src]="mercuryLogoPath" alt="Mercury Logo" class="mercury-logo" />
  </div>

  <div class="footer-body">
    <div class="footer-options">
      <div class="footer-option">
        <a
          class="subtitle-small"
          href="https://www.shipmercury.com/about-us"
          rel="noopener"
          target="_blank"
          >About Mercury</a
        >
      </div>
      <div class="footer-option">
        <a
          class="subtitle-small"
          href="https://www.shipmercury.com/terms-conditions"
          rel="noopener"
          target="_blank"
          >Terms and Conditions</a
        >
      </div>
      <div class="footer-option">
        <a
          class="subtitle-small"
          href="https://www.shipmercury.com/shipmercury/media/documents/mercuryprivacypolicy.pdf"
          rel="noopener"
          target="_blank"
          >Privacy Statement</a
        >
      </div>
      <div class="footer-option">
        <a
          class="subtitle-small"
          href="https://www.shipmercury.com/shipmercury/media/documents/mercuryclaimsprocessing.pdf"
          rel="noopener"
          target="_blank"
          >Claim Processing</a
        >
      </div>
    </div>
    <div class="copyright">
      <p class="m-0 subtitle-small">
        &copy; {{ currentYear }} Mercury Business Services. All rights reserved.
      </p>
    </div>
  </div>
</footer>
